<style scoped>
.ivu-col + .ivu-col {
	margin-left: 10px;
}
</style>
<template>
	<div>
		<!-- <PageTable ref="tableInst" :columns="columns1" :tableHeight="300" :data="row"></PageTable> -->
		<Row>
			<Col span="11">
				<Table border  ref="tableOfflineEvents" :columns="columnsOfflineEvents" :data="dataOfflineEvents" size="small"></Table>
			</Col>
			<Col span="11">
				<Table border  ref="tableInitEvents" :columns="columnsInitEvents" :data="dataInitEvents"  size="small"></Table>
			</Col>
		</Row>
	</div>
</template>
<script>
	import PageTable from '@/components/public/PageTable/PageTable.vue';
	export default {
		props: {
			row: Object
		},
		components: {
			PageTable
		},
		data() {
			return {
				dataOfflineEvents: this.row.OfflineEvents,
				columnsOfflineEvents: [
					{
						title: this.$tt('序号'),
						type: 'index',
						width: 60
					},
					{
						title: this.$tt('最后通信时间'),
						key: 'LastCommTime',
						minWidth: 150,
					},
					{
						title: this.$tt('离线时信号强度'),
						key: 'LastRssi',
						minWidth: 120,
					},
					{
						title: this.$tt('信号强度'),
						key: 'LastRssi',
						width: 100,
						render: (h, params) => {
							//return h('div', (params.row.SimRssi === 255 || params.row.SimRssi === 0) ? '-' : params.row.SimRssi);
							if ((params.row.LastRssi > 0 && params.row.LastRssi < 20) || (params.row.LastRssi >= -156 && params.row.LastRssi < -105)) {
								return h('img', {
									attrs: { src: require('@/assets/rssi-1.png') },
									style: { width: '20px' }
								});
							} else if ((params.row.LastRssi >= 20 && params.row.LastRssi < 23) || (params.row.LastRssi >= -105 && params.row.LastRssi < -95)) {
								return h('img', {
									attrs: { src: require('@/assets/rssi-2.png') },
									style: { width: '20px' }
								});
							} else if ((params.row.LastRssi >= 23 && params.row.LastRssi < 26) || (params.row.LastRssi >= -95 && params.row.LastRssi < -88)) {
								return h('img', {
									attrs: { src: require('@/assets/rssi-3.png') },
									style: { width: '20px' }
								});
							} else if ((params.row.LastRssi >= 26 && params.row.LastRssi < 29) || (params.row.LastRssi >= -88 && params.row.LastRssi < -80)) {
								return h('img', {
									attrs: { src: require('@/assets/rssi-4.png') },
									style: { width: '20px' }
								});
							} else if ((params.row.LastRssi >= 29 && params.row.LastRssi < 33) || (params.row.LastRssi >= -80 && params.row.LastRssi < -43)) {
								return h('img', {
									attrs: { src: require('@/assets/rssi-5.png') },
									style: { width: '20px' }
								});
							}
						}
					},
				],
				dataInitEvents: this.row.InitEvents,
				columnsInitEvents: [
					{
						title: this.$tt('序号'),
						type: 'index',
						width: 60
					},
					{
						title: this.$tt('初始化出错时间'),
						key: 'LastErrorTime',
						minWidth: 150,
					},
					{
						title: this.$tt('出错时的步骤'),
						key: 'LastStep',
						minWidth: 110,
					}
				]
			}
		}
	};
</script>
